/**
 * TextsPanel component
 * @constructor app.editor.mediatabs.TextsPanel
 * @param {object} dom DOM
 */
fx.ns("desktop.common.panels", class TextsPanel extends fx.components.VBox 
{   
	constructor(model /*texts, book*/)
	{
		super(/*texts*/);

		this.model = model;
		this.data = model.texts;
		this._book = model.creation;
		//this._book = book;
	}
 

	get data()
	{
		return super.data;
	}

	/*set data(val)
	{
		super.data = val;

		if (this.grid)
			this.grid.data = val;
	}*/

	set data(val)
	{
		if (val instanceof fx.ModelArray)
			super.data = val;
		else
		if (val)
		{
			this.model = val;
			this.data = val.texts;
			this._book = val.creation;
		}

		if (this.grid && val)
			this.grid.data = val;
	}


	get book()
	{
		return this._book;
	}

	set book(val)
	{
		this._book = val;
		if (this.initialized && this._book)
			this.data.loadRecommended( this._book.themeid );
	}

	set renderers(val)
	{
		if (this.grid)
			this.grid.renderers = val;
	}



	onReady()
	{
		super.onReady();

        this.on("click", this.onTextClick, this.addTextbutton);

        if (fx.get("app") != "calendar" && this.data.length == 0)
        {
            this.grid.loading(true);

            this.data.loadRecommended( this.book );
            this.on("loaded", this._onLoaded, this.data);
        }
	}

	_onLoaded()
	{
		this.grid.loading(false);
	}

	create()
	{
		super.create();

		this.addTextbutton = new fx.components.Button({label : fx.text("Ajouter du texte"), className:"add-text"});
        this.addChild(this.addTextbutton, {width:"100%"});

		this.grid = new fx.components.VerticalGridDynamic( {	data : this.data,
																maxElementsPerRow : 2,
																tilesSameSize : true,
																maxRowHeight : 180,
																childEffect : "",
																renderers : { Text : shared.renderers.TextRenderer } } );
		
		this.addChild(this.grid, {height:"fill", width:"100%", top : 10});		
        
    }

    onTextClick()
	{
		this.book.event("add-component", {    
			component_type : "text",
			content: "text", 
			creation : "manual"
		} );
	}
	
	destroy()
    {
		super.destroy();
		this.grid = null;
	}

});